import React, {useEffect, useState} from "react";

import { useNavigate } from "react-router-dom";

import { getParametrosURL } from '../componentes/apoio/suporte';
import Skeleton from 'react-loading-skeleton';
import { getToken, getSolicitacao } from "../componentes/api/DataApi";

export default function TokenPage() {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);

        montarParametros();
    }, []);

    const montarParametros = () => {
        const paramURL = getParametrosURL();

        if (paramURL && paramURL.session_state && paramURL.code)
        {
            localStorage.setItem("session_state", paramURL.session_state);
            localStorage.setItem("code", paramURL.code);

            getToken(paramURL.code, callbackToken);
        }
        else {
            localStorage.removeItem("session_state");
            localStorage.removeItem("code");

            navigate("/erro/?erro=101");
        }
    
        setLoading(false);
    }

    const callbackToken = (response) => {
        if (response && response.codigo === 0) {
            getSolicitacao(response.access_token, callbackSolicitacao);
        }
        else {
            navigate("/erro/?erro=102");
        }
    }

    const callbackSolicitacao = (response) => {
        navigate("/venda");
    }

    return (
        <>
        {loading &&
            <>
            <div className="d-flex flex-column w-100 align-items-center">
                <div className="d-flex flex-column bg-padrao align-items-center" style={{width: "1150px"}}>
                    <div className="d-flex flex-row justify-content-between w-100">
                        <Skeleton count={1} width={"150px"} height={"70px"} />
                        <Skeleton count={1} width={"190px"} height={"70px"} />
                    </div>

                    <div className="d-flex flex-column" style={{marginTop: "40px", width: "100%"}}>
                        <Skeleton count={40} height={"20px"} />
                    </div>
                </div>
            </div>
            </>
        }
        </>
    )
}